import type { DataTransferDomain, DataTransferResponse } from '@/protocol/OcppAdapter';

export function buildDataTransferRequest(req: DataTransferDomain): Record<string, unknown> {
  const wire: Record<string, unknown> = { vendorId: req.vendorId };
  if (req.messageId !== undefined) wire['messageId'] = req.messageId;
  if (req.data !== undefined) wire['data'] = req.data;
  return wire;
}

export function parseDataTransferResponse(payload: Record<string, unknown>): DataTransferResponse {
  const out: DataTransferResponse = { status: payload['status'] as DataTransferResponse['status'] };
  if (typeof payload['data'] === 'string') return { ...out, data: payload['data'] };
  return out;
}
